import React, { useState } from "react";
import { observer } from "mobx-react";
import "react-select-search/style.css";
import { useHistory, Link } from "react-router-dom";
import authStore from "../../../../../Stores/AuthStore/AuthStore";
import { CheckStep } from "../../../registration1";
import UIBlockButton, {
  UIBlockButtonColor,
} from "../../../../../Components/Katelinlis/Button.tsx";
import { UIInputBlock } from "./UIInputBlock";

export const RegStep3Parent = observer((props) => {
  let history = useHistory();

  if (authStore.isRegistration) {
    CheckStep("teacher");
  }

  return (
    <>
      <div
        className="RegistrationFirstStepMainContainer"
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translateY(-50%) translateX(-50%)",
        }}
      >
        <h1
          style={{
            margin: "32px 0",
            fontSize: "24px",
            fontWeight: "bold",
            fontFamily:
              "'Open Sans','Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
            WebkitUserSelect: "none",
            MsUserSelect: "none",
            UserSelect: "none",
          }}
        >
          Регистрация родителя
        </h1>
        <div
          className="RegistrationFirstStepContainer"
          style={{
            display: "flex",
            width: "876px",
            maxWidth: "100%",
            margin: "0 auto",
            flexDirection: "row",
            flexWrap: "wrap",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="OnlyDesktop">
            <UIInputBlock
              type="text"
              placeholder="Имя* и фамилия*"
              width="280px"
              height="48px"
              margin="12px 8px"
            />
          </div>

          <div className="OnlyMobile">
            <UIInputBlock
              type="text"
              placeholder="Имя*"
              width="280px"
              height="48px"
              margin="12px 8px"
            />
          </div>
          <div className="OnlyMobile">
            <UIInputBlock
              type="text"
              placeholder="Фамилия*"
              width="280px"
              height="48px"
              margin="12px 8px"
            />
          </div>

          <UIInputBlock
            type="email"
            placeholder="Почта*"
            width="280px"
            height="48px"
            margin="12px 8px"
          />
          <UIInputBlock
            type="password"
            placeholder="Пароль*"
            width="280px"
            height="48px"
            margin="12px 8px"
            eye
          />
          <UIInputBlock
            type="password"
            placeholder="Подтвердите пароль*"
            width="280px"
            height="48px"
            margin="12px 8px"
            eye
          />
        </div>

        <p
          className="RegistrationFirstStepAgree"
          style={{
            margin: "12px auto 40px",
            width: "576px",
            maxWidth: "100%",
            textAlign: "left",
          }}
        >
          Нажимая на далее, вы принимаете{" "}
          <a
            href="/rules"
            style={{
              textDecoration: "none",
              color: "#4FC1E9",
            }}
          >
            условия использования
          </a>
        </p>

        <Link to="/registration/parent-code">
          <UIBlockButton style={UIBlockButtonColor.Primary} text="Далее" />
        </Link>

        <p
          className="RegistrationFirstStepAgree-mobile"
          style={{
            display: "none",
          }}
        >
          Нажимая на далее, вы принимаете{" "}
          <a
            href="/rules"
            style={{
              textDecoration: "none",
              color: "#4FC1E9",
            }}
          >
            условия&nbsp;использования
          </a>
        </p>
      </div>

      {/*</form>*/}
      <svg
        className="step_reg"
        width="70"
        height="10"
        viewBox="0 0 70 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="65" cy="5" r="5" fill="#434A54" fillOpacity="0.5" />
        <circle cx="35" cy="5" r="5" fill="#434A54" />
        <circle cx="5" cy="5" r="5" fill="#434A54" fillOpacity="0.5" />
      </svg>
    </>
  );
});

export default RegStep3Parent;
